import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import {MatDatepicker} from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { fuseAnimations } from '@fuse/animations';
import {TranslateService} from '@ngx-translate/core';
import { SheduleService } from "app/main/pagina/certificar/services/shedule.service";
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import Swal from 'sweetalert2';
import * as catalogo from '../catalogo';
import * as backInter from 'app/auth/auth-data.model';
import { ModalRecoComponent } from "./modal-reco/modal-reco.component";
import { SurveyCheckComponent } from "app/main/pagina/productos/certificar/tipo_2/programacion/vista-gen/survey-check/survey-check.component";
const moment = require('moment');
const momentTz = require('moment-timezone');
import { AuthService } from 'app/auth/auth.service';
import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import { EditorEncuestaService } from "app/main/pagina/productos/certificar/tipo_2/editor-encuesta/editor-encuesta.service";
import { LyDialog } from '@alyle/ui/dialog';
import { ModalImgComponent } from "app/main/pagina/productos/certificar/tipo_2/editor-encuesta/modal-img/modal-img.component";
import { CloudService } from 'app/main/pagina/tools/cloud/cloud.service';
import { DATOS_API } from 'app/auth/auth.datos';
import { first } from 'rxjs/operators'
import { SurveyProductService } from "app/main/wizard-cgo/survey-product/survey-product.service";
import { CrearEncuestaService } from 'app/main/pagina/productos/nom35/v3/crear-encuesta/creacion.service';
import { ProgramacionN35Service} from 'app/main/wizard-n35encuestador/services/programacionn35.service';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
@Component({
  selector: 'vista-gen',
  templateUrl: './vista-gen.component.html',
  styleUrls: ['./vista-gen.component.scss'],
  animations   : fuseAnimations
})
export class VistaGenComponent implements OnInit {

  comunicacionCreacion: any;
  @Input() actualizaPaso: Observable<any>;
  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();
  @Output() dataPiloto: EventEmitter<any> = new EventEmitter();
  @Output() revisarModificaciones: EventEmitter<any> = new EventEmitter();
  @Output() actualizaFlagCambios: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('fecRecordatorio', { read: undefined }) calReco: MatDatepicker<Date>;
  @Output() seccionesEspeciales: EventEmitter<any> = new EventEmitter();

  // Datos certificar vigente
  productoCertificar: backInter.prodNorma35;
  //boolean paso completo
  pasoCompleto = false;

  idiomaActual:string;

  cards = JSON.parse(JSON.stringify(catalogo.cards));
  secciones = JSON.parse(JSON.stringify(catalogo.secciones));

  logoOK: boolean;
  reqTecOK: boolean;
  validarIzzi: boolean;

  idFechaLanzamiento: string;
  fechaLanzamiento: any;
  fechasRecordatorios: any[] = [];
  // historySurveyGeneration:any= [];
  // fechaUltimaCreacion:any;
  // SurveyGeneration:boolean=false; //variable que permite ver el combo de historial de creacion encuesta

  numSecciones = 0;
  seccionesCompletas = 0;
  indices:any[] = [];
  creandoEncuesta: boolean;
  tamanioTagSecc: number;
  progresoEncuesta = 0;
  procesoActual: string;
  procesoFinalizado: boolean;
  procesoOK = true;
  recrearEncuesta: boolean;
  recrearEncuestaBtn: boolean=false;
  seccionEncuesta: boolean;  //se usa para validacion del mensaje "encuesta creada"
  token:any;
  datosSurveyCheck:any;
  checarEncuesta:boolean=false;
  banderaRTV3:boolean=false;


  filtroLanzamiento = (d: Date | null): boolean => {
    var moment = require('moment');
    return moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
  };
  filtroRecordatorios: any;
  nameUserAdmin:any="";

  zonasUTC = zonasUTC;
  idiomaUtc: string;
  instUtc: number;
  indiceZona: number;
  diferenciaUtc: number;
  offsetPipe: string;
  instituto:number;
  urlRequerimientosV3: string;

  validationUser: boolean;
  userData:any;
  nivelNotificacion:number;
  modalCambios:boolean=false;
  preReqOK: boolean;


  //productos para la edicion de logotipo de certificado
  productosPermitidosCert = [
    'c3',
    'am1',
    'td1',
    'pe1',
    // 'm7',
    // 'p1',
    // 'f1'
  ];
  brokersPermitidosCert = ['1','2','18'];
  jsonLogos: any;
  carpetaImagenes: any;
  direccionRaiz = "./4fa42aa0ba652605cada43bca0fc6389/";
  tipoLogoCargado = 0;
  nombreEmpresa: string;
  brokerConfig: any;

  seccEspHabilitadas: boolean;
   createSurveyNomMenos50:boolean=false;
   createSurveyNomMas50:boolean=false;
  encuestaCreada: boolean=false;
  constructor(
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private dialog: MatDialog,
    private programacionService: ProgramacionService,
    private encuestaService: EncuestaService,
    private sheduleService: SheduleService,
    private wizardService: WizardService,
    private router: Router,
    public authService: AuthService,
    private idiomasService: IdiomasService,
    private odsService: ODSService,
    private editorEncSrv: EditorEncuestaService,
    private _dialog: LyDialog,
    private _cd: ChangeDetectorRef,
    private cloudService: CloudService,
    private surveyProductService: SurveyProductService,
    private crearEncuestaSrv: CrearEncuestaService,
    private programacionServicen35: ProgramacionN35Service,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    this.programacionService.ordenProg.subscribe( (resu) => {
      console.log("se envio orden desde navbar: ",resu);
      if(this.jsonLogos){
        this.revisaLogoEmpresa();
      }
      this.logoOK = true;
      if(this.logoOK && this.banderaRTV3){
        this.cards[0].completo = true;
        this.preReqOK = true;
      }
    });

    if(localStorage.getItem('tipoIzzi')){
      this.validarIzzi=true;
    }
    if(localStorage.getItem('userBypass')){
      this.userData = JSON.parse(localStorage.getItem('userBypass'));
      if(this.userData.level == 3 || this.userData.level == 2){
        this.validationUser = true;
        this.nameUserAdmin=this.userData.user;
      }
      else{
        this.validationUser = false;
        this.nameUserAdmin="";
      }
    }
    else this.validationUser = false;
  }

  ngOnInit() {
    this.recibeDatosSP();
    this.getInfoEmpresa();
    this.getBrokerConfig();

    this.obtieneCertificarActual();
    // this.getestatusSecciones();
    this.prerequisitos();
    this.instituto=parseInt(localStorage.getItem('instituto_id'));
    console.log('this.instituto',this.instituto);

    this.comunicacionCreacion = this.actualizaPaso.subscribe( (datos) => {
      console.log("se envio datos desde componente editor: ",datos);
      this.getStatusSeccion();
      this.calculoOffsetPipe();
    });
    this.calculoOffsetPipe();

    switch (localStorage.getItem('tipoProducto')) {
      case 'c3': this.urlRequerimientosV3 = '/requerimentsLandingcertify_3/requirements-details'; break;  //certificar 3
      case 'c4Plata': this.urlRequerimientosV3 = '/requerimentsLandingcertify_4/requirements-details'; break;  //certificar 3
      case 'm7': this.urlRequerimientosV3 = '/requerimentsLandingmeasurement_t7/requirements-details'; break;  //medir 3
      case 'p1': this.urlRequerimientosV3 = '/requerimentsLandingPulse_t1/adminpulsecheck/requirements-details'; break;  //pulse 3
      case 'f1': this.urlRequerimientosV3 = '/requerimentsLandingfocus/adminfocusarea/requirements-details'; break;  //pulse 3
      case 'am1': this.urlRequerimientosV3 = '/requerimentsLandingamco_1/requirements-details'; break;  //pulse 3
      case 'td1': this.urlRequerimientosV3 = '/requerimentsLandingtraba_digno/requirements-details'; break;  //pulse 3
      case 'pe1': this.urlRequerimientosV3 = '/requerimentsLandingprimer_emple/requirements-details'; break;  //pulse 3
      case '5': this.urlRequerimientosV3 = '/requerimentsLandingNom35/requirements-details'; break;  //pulse 3
      case 'NOM35V3': this.urlRequerimientosV3 = '/requerimentsLandingNom35/requirements-details'; break;  //pulse 3
    }
  }
   recibeDatosSP(){
    this.surveyProductService.enviaDatosASurvProd({ recuperaInformacion: true });
    this.surveyProductService.recibidosSurvProd.pipe(first()).subscribe((datos:any) => {
      if(datos.recuperaInformacion == true){
        this.seccEspHabilitadas = datos.surveyProduct.enableCustom;
        console.log("secciones especiales:",this.seccEspHabilitadas);
        this.seccionesEspeciales.emit(this.seccEspHabilitadas);
      }
    });
  }

  getBrokerConfig(){
    this.wizardService.getBrokerConfig().subscribe((respuesta:any) => {
      console.log('respuesta getBrokerConfig', respuesta);

      this.brokerConfig = respuesta.catBrokerConfiguration;
      // this.checkLogosSurvey();
    });
  }

  // checkLogosSurvey(bypass?:boolean){
  //   if(!bypass){
  //     // if(!this.productosPermitidosCert.includes(localStorage.getItem('tipoProducto')) || !this.brokersPermitidosCert.includes(localStorage.getItem('instituto_id'))){
  //     //   this.cards[1].visibleCertificado = false;
  //     //   this.cards[1].logoCertificado = true;
  //     // }
  //     let prueba_1 = this.brokerConfig.logoCertificado.find(item => item.broker == parseInt(localStorage.getItem('instituto_id')));
  //     let prueba_2= false;
  //     if(prueba_1 != undefined){
  //       prueba_2 = prueba_1.productos.includes(localStorage.getItem('tipoProducto'));
  //       console.log('prueba_2',prueba_2);
  //       if(prueba_2 == false){
  //         this.cards[1].visibleCertificado = false;
  //         this.cards[1].logoCertificado = true;
  //       }
  //     } else{
  //       this.cards[1].visibleCertificado = false;
  //       this.cards[1].logoCertificado = true;
  //     }
  //
  //     this.editorEncSrv.getJsonLogos().subscribe((respuesta:any) => {
  //       console.log("getJsonLogos:",respuesta);
  //       if(respuesta.success){
  //         this.jsonLogos = respuesta.jsonLogos;
  //         this.revisaLogoEmpresa();
  //         // if(!this.productosPermitidosCert.includes(localStorage.getItem('tipoProducto')) || !this.brokersPermitidosCert.includes(localStorage.getItem('instituto_id'))){
  //         if(prueba_2 == false){
  //           if(!this.jsonLogos.logos.certificate.set){
  //             this.jsonLogos.logos.certificate.set = true;
  //             this.actualizaJsonLogos();
  //           }
  //         }
  //         let refLogos = this.jsonLogos.logos;
  //         if(refLogos.company.set && refLogos.certificate.set){
  //           this.cards[1].completo = true;
  //         }
  //       }
  //     });
  //   } else{
  //     let refLogos = this.jsonLogos.logos;
  //     if(refLogos.company.set && refLogos.certificate.set){
  //       this.cards[1].completo = true;
  //     }
  //     if(this.tipoLogoCargado == 2){  //si recién se cargó el logo de certificado, se muestra la vista previa
  //       this.zoomCertificado(refLogos.certificate.image);
  //     }
  //   }
  // }

  revisaLogoEmpresa(){
    let refUrlImg = this.jsonLogos.logos.company.image;
    if(refUrlImg == '' || !refUrlImg.includes("http")){
      this.jsonLogos.logos.company.set = false;
      this.authService.getLogo().subscribe( (data: any) => {
        console.log("getLogo:",data);
        if(data.message=="702"){
          let url = DATOS_API.url.split(":");
          let htp = DATOS_API.url.split("/");
          let rutaimagen = `${htp[0]}${url[1]}/surveyadministrator/backend/${data.rutaArchivo}`;
          console.log("urlLogoEmpresa:",rutaimagen);
          this.jsonLogos.logos.company.image = rutaimagen;
          this.jsonLogos.logos.company.set = true;
          // this.actualizaJsonLogos();
        } else if(data.message == 'logos_getLogo_1'){

        }
      });
    }
  }

  zoomImagen(url:string, opcion:number){
    let tagImagen:string;
    switch (opcion) {
      case 1: //imagen
        tagImagen = `<img src="${url}" alt="" style="border:1px solid grey!important"><br><br><em>${this.translateSrv.instant('SHEDULE2_0.CARDS.PASO7.LOGO_EMP_INFO')}</em>`;
      break;
      case 2: //video
        tagImagen = `<video src="${url}" alt="" width="100%" autoplay controls>`;
      break;
    }
    Swal.fire({
      // title: this.translateSrv.instant('EDITOR.ELEMENTOS.GUIA'),
      // html: '<img src="https://www.harley-davidson.com/content/dam/h-d/images/product-images/bikes/motorcycle/2021/2021-sport-glide/2021-sport-glide-f16/2021-sport-glide-f16-motorcycle.jpg" alt="" width="100%">',
      html: tagImagen,

      confirmButtonText: 'OK',
      width: '30%'
    });
  }

  zoomCertificado(url:string){
    const dialogRef = this.dialog.open(ModalRecoComponent, {
      width: '40%',
      data: {
        opcion: 'certificado',
        imagen: url,
        nombreEmpresa: this.nombreEmpresa
      }
    });
  }

  getInfoEmpresa(){
    this.cloudService.getInfoEmpresa(localStorage.getItem('companyID')).subscribe((respuesta:any) => {
      console.log("getInfoEmpresa:",respuesta);
      if(respuesta.message == 'Success'){
        this.nombreEmpresa = respuesta.data.nombreEmpresa;
        // this.direccionRaiz = this.direccionRaiz + respuesta.data.nombreEmpresa + "/";
        this.direccionRaiz = this.direccionRaiz + localStorage.getItem('companyID') + "/";
        this.getRaiz();
      }
    });
  }

  getRaiz(){
    let idEmpresa = localStorage.getItem('companyID');
    this.cloudService.getCarpetaRaiz(idEmpresa).subscribe( (respuesta:any) => {
      console.log("getRaiz:",respuesta);
      if(respuesta.success){
        if(respuesta.carpetas.length == 0){
          this.guardaCarpeta('editorImages');
        } else{
          let datosCarpetaImgs = respuesta.carpetas.find(item => item.nombre == 'editorImages');
          if(datosCarpetaImgs != undefined){
            // this.revisaDirectorios(datosCarpetaImgs);
            this.carpetaImagenes = datosCarpetaImgs;
            // this.getImagenesCarpeta();
          } else{
            this.guardaCarpeta('editorImages');
          }
        }
      }
    });
  }

  guardaCarpeta(nombre:string, ubicacion?:string, carpetaAssets?:any){
    let datos:any = {
      nombre: nombre,
      ubicacion: ubicacion != undefined ? ubicacion : this.direccionRaiz,
      empresaId: localStorage.getItem('companyID')
    };
    if(carpetaAssets){
      datos.carpetaId = carpetaAssets._id;  //solo cuando no es la raiz
    }
    console.log(datos);
    this.cloudService.guardaCarpetaITBM(datos).subscribe((respuesta:any) => {
      console.log("guardaCarpetaITBM:",respuesta);
      if(respuesta.success){
        if(nombre == 'editorImages'){
          this.getRaiz();
        }
      }
    }, error => {
      console.log(error);
    });
  }

  openCropperDialog(event: Event) {
    // this.cropped = null!;
    console.log("event:",event);
    let configEspecial: any;
    let mensaje: string;
    switch (this.tipoLogoCargado) {
      case 1: //empresa
        configEspecial = {
          width: 250,
          height: 250,
          type: 'image/png',
          // fill: 'white',
          keepAspectRatio: true,
          // responsiveArea: true,
          output: {
            height: 200,
            width: 200
          },
          extraZoomOut: true,
          // resizableArea: true
        };
      break;
      case 2: //certificado
        configEspecial = {
          width: 350,
          height: 210,
          // type: 'image/png',
          // fill: 'white',
          keepAspectRatio: true,
          // responsiveArea: true,
          output: {
            height: 240,
            width: 400
          },
          extraZoomOut: true,
          // resizableArea: true
        };
        mensaje = this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CARGA_CERT');
      break;
    }
    this._dialog.open<ModalImgComponent, any>(ModalImgComponent, {
      data: {event, configEspecial, mensaje},
      disableClose: true,
      width: "700px"
    // }).afterClosed.subscribe((result?: ImgCropperEvent, objDrop?: any) => {
    }).afterClosed.subscribe((result?: any) => {
      let [resultado,objDrop] = result;
      if (resultado) {
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.GUARDANDO_LOGO'),
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()
          }
        });
        // this.cropped[`${pagina}_${paso}_${elemento}`] = resultado.dataURL;
        this._cd.markForCheck();
        console.log("resultado:",resultado);
        console.log("objDrop:",objDrop);
        let nomSplit = objDrop.name.split(".");
        fetch(resultado.dataURL)
          .then(res => res.blob()) // Gets the response and returns it as a blob
          .then(blob => {
            console.log("blob:",blob);
            let nombreArchivo: string = `${Date.now()}.${nomSplit[nomSplit.length - 1]}`;
            let file = new File([blob], nombreArchivo, {type: objDrop.type});
            console.log("file:",file);
            this.guardaImagenCargada(file);
        });
      }
    });
  }

  guardaImagenCargada(archivo:any){
    let carpetaBroker = this.carpetaImagenes;
    let ubicacion = `${carpetaBroker.ubicacion}${carpetaBroker.nombre}/`;
    const reader: FileReader = new FileReader();
    let fd = new FormData();
    fd.append('file',archivo, archivo.name);
    fd.append('ubicacion',ubicacion);
    fd.append('carpetaId',carpetaBroker._id);
    // fd.append('ubicacion',this.direccionRaiz);
    // fd.append('empresaId',this.idEmpresa);
    // console.log(...fd);
    // new Response(fd).text().then(console.log);
    this.cloudService.guardaArchivo(fd).subscribe((res) => {
        if(res.status){
          if(res.status == "progress"){
            // this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          console.log("cargaOk:",res);
          let url = DATOS_API.url.split(":");
          let htp = DATOS_API.url.split("/");
          let urlFileManager = DATOS_API.urlFileManager;
          let urlImagenCargada = htp[0] + url[1] + urlFileManager + res.archivo.ubicacion.substr(2) + res.archivo.nombre;
          switch (this.tipoLogoCargado) {
            case 1: //logo empresa
              this.jsonLogos.logos.company.image = urlImagenCargada;
              this.jsonLogos.logos.company.set = true;
            break;
            case 2: //logo certificado
              this.jsonLogos.logos.certificate.image = urlImagenCargada;
              this.jsonLogos.logos.certificate.set = true;
            break;
          }
          // this.actualizaJsonLogos();
          Swal.close();
          // this.getImagenesCarpeta();
          // this.copiarURL(urlImagenCargada);
        }
        else{
          if(res.message == 'archivo_save_1'){
            // this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
          }
        }
      },
      (err) => console.log(err)
    );
  }

  // actualizaJsonLogos(){
  //   this.editorEncSrv.updateJsonLogos(this.jsonLogos._id, { logos: this.jsonLogos.logos }).subscribe((respuesta:any) => {
  //     console.log('updateJsonLogos:',respuesta);
  //     this.checkLogosSurvey(true);
  //   });
  // }

  irPaso(numPaso: number){
    this.cambiaPaso.emit(numPaso);
  }

  cargaLogoEmpresa(){
    console.log("se hizo clic al boton img");
    this.programacionService.enviaNavbar("hola prro");
  }

  preCrearEncuesta(){

    console.log('recrearEncuestaBtn',this.recrearEncuestaBtn);

    if(this.logoOK && this.banderaRTV3){
      if(this.cards[0].completo){
        let texto = "SHEDULE2_0.MODALES.ENCUESTA.CREAR_3";
        // let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
        let rspSi = 'MODALES.ACCIONES.aceptar';
        let rspNo = 'MODALES.ACCIONES.cancelar';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
        this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
        Swal.fire({
          title: texto,
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,


          confirmButtonText: rspSi,
          cancelButtonText: rspNo
        }).then((result) => {
          if (result.value) {
            this.crearEncuesta();
          }
        });
      } else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE.LOGOSSURVEY'),3);
      }
    }
    else{
      if(!this.logoOK){
        this.mensajeSwal(this.translateSrv.instant('SHEDULE.SUBIRLOGO'),3);
      }
      else if(!this.banderaRTV3){
        this.mensajeSwal(this.translateSrv.instant('SHEDULE.ACEPTARREQUERIMIENTOS'),3);
      }
    }
  }

  // crearEncuestaBack(){
  //   this.reiniciarVariables();
  //   this.secciones.forEach((seccion,i) => {
  //     if(seccion.visible){
  //       this.numSecciones++;
  //       this.indices.push(i);
  //     }
  //   });
  //   this.tamanioTagSecc = 100 / this.numSecciones;
  //   console.log("numsecciones:",this.numSecciones," | tamaniotag:",this.tamanioTagSecc," | progresoInicial:",this.progresoEncuesta);
  //
  //   this.creandoEncuesta = true;
  //   this.procesoActual = this.secciones[0].proceso;
  //
  //   //seccion error
  //   let secErr = Math.floor(Math.random() * (this.numSecciones - 1 + 1)) + 1;
  //   let esperaImg = setInterval(() => {
  //     this.procesoActual = "";
  //
  //     if(this.seccionesCompletas == this.numSecciones){
  //       this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
  //       setTimeout(() => {
  //         this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
  //         this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_2'),1);
  //       }, 200);
  //       console.log("secciones completas:",this.seccionesCompletas," | progreso:",this.progresoEncuesta);
  //       clearInterval(esperaImg);
  //       this.procesoFinalizado = true;
  //     }
  //     else{
  //       if(this.seccionesCompletas == 0){
  //         this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
  //       }
  //       else{
  //         this.progresoEncuesta += this.tamanioTagSecc;
  //       }
  //       //prueba de una seccion con fallo
  //       if(this.seccionesCompletas == secErr){
  //         this.secciones[this.indices[this.seccionesCompletas]].fallo = true;
  //         // if(this.secciones[this.indices[this.seccionesCompletas+1]]){
  //           setTimeout(() => {
  //             this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].error;
  //           }, 200);
  //         // }
  //         clearInterval(esperaImg);
  //         this.procesoFinalizado = true;
  //         this.procesoOK = false;
  //       }
  //       else{
  //         this.secciones[this.indices[this.seccionesCompletas]].completo = true;
  //         if(this.secciones[this.indices[this.seccionesCompletas+1]]){
  //           setTimeout(() => {
  //             this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].proceso;
  //           }, 200);
  //         }
  //         else{
  //           setTimeout(() => {
  //             this.procesoActual = "SHEDULE2_0.SECCIONES.DETALLES";
  //           }, 200);
  //         }
  //         this.seccionesCompletas++;
  //         console.log("secciones completas:",this.seccionesCompletas," | progreso:",this.progresoEncuesta);
  //       }
  //
  //     }
	// 	}, 2000);
  // }

  reiniciarVariables(){
    this.secciones.forEach(seccion => {
      seccion.completo = false;
      seccion.fallo = false;
    });
    this.numSecciones = 0;
    this.seccionesCompletas = 0;
    this.tamanioTagSecc = 0;
    this.progresoEncuesta = 0;
    this.procesoActual = "";
    this.procesoFinalizado = false;
    this.procesoOK = true;
  }

  traduceTextosTS(){
    // switch(this.translateSrv.currentLang){
    //   case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
    //   default: this.idiomaActual = 'en';
    // }
  }
  calculoOffsetPipe(){
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == parseInt(localStorage.getItem('instituto_id')));
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
    console.log(localStorage.getItem('instituto_id'));
    // this.city_name='TOOLBAR.CITIES.'+localStorage.getItem('instituto_id');
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
      case 4: tipo = 'info'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.encuestaService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
    let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            if(fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              this.modalCambios=producto.modalCambios;
              this.token=producto.tokenConfig;
              // this.surveyCheckService(this.token);
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      this.getStatusSeccion();
      this.getsurveyPilot();
      this.idiomasService.getNivelNotificacionCatServ(this.instituto).subscribe( (data: any) => {
        console.log('entro get catalogo niveles notificaciones',data);
        this.nivelNotificacion=data.catlNotificationBroker[0].secciones.encuesta.levelNotification;
        console.log('this.nivelNotificacion::',this.nivelNotificacion);
      });
      // this.getHistrialCreacionEncuesta();
      // this.getEstatusEncuestaNuevo();*****checar servicio
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getStatusSeccion(){
    this.crearEncuestaSrv.getStatusSeccCreacionEncuesta(this.productoCertificar.idNorma35).subscribe( (data: backInter.getStatusIndiv) => {
    // this.encuestaService.getStatusEncuesta(this.productoCertificar.idNorma35).subscribe( (data: backInter.getStatusIndiv) => {
      if(data.estatus === 3){
        this.pasoCompleto = true;
      }else{
        this.pasoCompleto = false;
      }

    });
  }

  getStatusModal(){
    let datos={
      productoId: this.productoCertificar.idNorma35,
      programacion: 1
    };
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
        this.modalInformativo('PROGRAMACION');
      }
    });
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      inputValidator: (result)=>{
        return new Promise((resolve)=>{
          if (result){
            this.updateStatusModal();
          }
          resolve(result);
        });
      },

      confirmButtonText: rspSi,
      allowOutsideClick: false
    })
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idNorma35,
      programacion: 2
    };
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  async getPilotoDataEncuesta(){
    let data={
      productoId: localStorage.getItem("productoID")
    };
    const respuesta: any = this.encuestaService.getPilotoDataEncuesta(data).toPromise().then((resultado: backInter.getEncuestaPilotoC2) => {
      console.log("getPilotoData:",resultado);
      if(resultado.message= "Success"){

        //envia los datos del piloto al componente padre
        this.dataPiloto.emit({
          data: resultado,
          procesoFinalizado: this.procesoFinalizado,
          productoCertificar: this.productoCertificar
        });
        // this.flag = true;
      }else{
        // this.flag = false;
      }
    });
  }

  // getestatusSecciones(){
  //   let data = {
  //     productoId: localStorage.getItem("productoID")
  //   }
  //   this.encuestaService.getStatusSecciones(data).subscribe((response:any) => {
  //     console.log("respGetSecc",response);
  //     this.secciones.forEach(seccion => {
  //       var BreakException = {};
  //       try {
  //         response.secciones.forEach( (seccionAgregada) => {
  //           if(seccion.id == seccionAgregada.nombre){
  //             seccion.visible = seccionAgregada.estatus;
  //             throw BreakException;
  //           }
  //         });
  //       } catch (e) {
  //         if (e !== BreakException) throw e;
  //       };
  //     });
  //     console.log("Secciones Tras filtro:",this.secciones);
  //
  //   }, error => {
  //     console.log(error);
  //   });
  // }

  // getEstatusEncuestaNuevo(){
  //   this.encuestaService.getEstatusEncuesta2().subscribe((respuesta: any) => {
  //     console.log("getStatEnc2",respuesta);
  //
  //     if(respuesta.newproduct){
  //       console.log("encuesta nueva");
  //       let encuestaOk = true;
  //       this.seccionEncuesta = respuesta.survey;
  //       this.recrearEncuesta = respuesta.recreateSurvey;
  //       this.recrearEncuestaBtn = respuesta.survey || respuesta.recreateSurvey;
  //       this.secciones.forEach(seccion => {
  //         switch (seccion.id) {
  //           case 'encuesta':
  //           seccion.visible = true;
  //           seccion.completo = respuesta.survey;
  //           break;
  //           case 'usuarios':
  //           seccion.visible = true;
  //           seccion.completo = true;
  //           break;
  //           case 'NPS': case 'Reactivos': case 'Control': case 'Demograficos': case 'Abiertas': case 'Forall': case 'Adicionales':
  //           let indice = respuesta.secciones.findIndex(item => item.nombre == seccion.id);
  //           if(indice != -1){
  //             seccion.visible = respuesta.secciones[indice].estatus;
  //             seccion.completo = respuesta.secciones[indice].insurvey && respuesta.secciones[indice].questions;
  //           }
  //           break;
  //         }
  //         if(seccion.visible && !seccion.completo){
  //           encuestaOk = false;
  //         }
  //       });
  //       if(encuestaOk){
  //         this.procesoFinalizado = true;
  //         this.checarEncuesta=true;
  //         this.procesoOK = true;
  //         this.progresoEncuesta = 100;
  //         this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
  //       }
  //       this.getPilotoDataEncuesta();
  //     }
  //     else{
  //       this.getEstatusEncuestaAnterior();
  //     }
  //
  //   }, error => {
  //     console.log(error);
  //   });
  // }

  // getEstatusEncuestaAnterior(){
  //   let data = {
  //     productoId: this.productoCertificar.idNorma35
  //   };
  //   this.encuestaService.getEstatusEncuesta(data).subscribe((respuesta: backInter.getEstatusEncuesta) => {
  //     console.log("getStatEnc",respuesta);
  //
  //     if(respuesta.success){
  //       console.log("encuesta anterior");
  //       if(respuesta.survey){
  //         this.seccionEncuesta = respuesta.survey;
  //         this.procesoFinalizado = true;
  //         this.procesoOK = true;
  //         this.progresoEncuesta = 100;
  //         this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
  //         this.secciones.forEach(seccion => {
  //           // seccion.completo = true;
  //           switch (seccion.id) {
  //             case 'NPS': seccion.completo = respuesta.nps; break;
  //             case 'Reactivos': seccion.completo = respuesta.reactivos; break;
  //             case 'Control': seccion.completo = respuesta.control; break;
  //             case 'Demograficos': seccion.completo = respuesta.demograficos; break;
  //             case 'Abiertas': seccion.completo = respuesta.abiertas; break;
  //             case 'Forall': seccion.completo = respuesta.forall; break;
  //             case 'Adicionales': seccion.completo = respuesta.adicionales; break;
  //           }
  //
  //         });
  //       }
  //     }
  //     this.getPilotoDataEncuesta();
  //   }, error => {
  //     console.log(error);
  //   });
  // }

  prerequisitos(){
    let datos = {
      productoId: localStorage.getItem('productoID')
    };
    this.encuestaService.getBanderas(datos).subscribe((respuesta:backInter.statusReqTec) => {
      console.log("getPreReq",respuesta);
      if(respuesta.success){

        this.logoOK = respuesta.logo;
        this.reqTecOK = respuesta.requerimientos || this.validarIzzi;

        if (!respuesta.requerimientos) {
          if (this.instituto==1) {
            console.log('entro en Mexico_City');
            if(respuesta.requerimientosv3){
              let { autentication,requirements,testAccess,testEmail,validationQ } = respuesta.requerimientosv3;
              this.banderaRTV3 = autentication && requirements && testAccess && testEmail && validationQ;
            }
          }else{
            console.log("no es Mexico_City");
            this.banderaRTV3 = true;
          }
        }else{
          this.banderaRTV3 = true;
        }
        console.log("banderaRTV3:",this.banderaRTV3);

        /////marca
        if(this.banderaRTV3 && this.logoOK){
          this.cards[0].completo = true;
          this.preReqOK = true;
        }
      }
    }, error => {
      console.log(error);
    });
  }

  verSeccionesAgregadas(){
    this.creandoEncuesta = !this.creandoEncuesta;
  }

  async crearEncuesta(){
    this.reiniciarVariables();
    this.secciones.forEach((seccion,i) => {
      if(seccion.visible){
        this.numSecciones++;
        this.indices.push(i);
      }
    });
    this.tamanioTagSecc = 100 / this.numSecciones;
    console.log("numsecciones:",this.numSecciones," | tamaniotag:",this.tamanioTagSecc," | progresoInicial:",this.progresoEncuesta);

    // if(this.seccEspHabilitadas == true){
    //   if(this.recrearEncuestaBtn == true){  //es true si la encuesta esta siendo recreada
    //     console.log("reasignando secciones");
    //     const respuesta: any = await this.encuestaService.reasignarSeccionesEspeciales().toPromise();
    //   }
    // }

    this.creandoEncuesta = true;
    this.procesoActual = this.secciones[0].proceso;
    if(this.seccionEncuesta){
      let data = {
        productoId: localStorage.getItem('productoID'),
        // recreateSurvey: true,
        // accionText:'recreateSurvey',
        // userAdministrator:this.nameUserAdmin,
      };
      this.pasoEncuesta(data);
    }else if(this.recrearEncuesta){
      let data = {
        productoId: localStorage.getItem('productoID'),
        // recreateSurvey: true,
        // accionText:'recreateSurvey',
        // userAdministrator:this.nameUserAdmin,
      };
      this.pasoEncuesta(data);
    }else{
      let data = {
        productoId: localStorage.getItem('productoID'),
        // recreateSurvey: false,
        // accionText:'createSurvey',
        // userAdministrator:this.nameUserAdmin,
      };
      this.pasoEncuesta(data);
      console.log("Es la primera vez");
    }
  }
  //PASOS CREACION DE ENCUESTA

  pasoEncuesta(data:any){
    this.sumaProgresoProceso();
    this.programacionServicen35.crearEncuesta(data).subscribe((respuesta:any) => {
      console.log("pasoEncuesta:",respuesta);

      if(respuesta.success == true){
        // this.enviaOrdenWizardNotificiaciones();
     this.createSurveyNomMenos50=respuesta.banderaMenos50;
     this.createSurveyNomMas50=respuesta.banderaMas50;
     this.secciones[2].visible=this.createSurveyNomMenos50;
     this.secciones[3].visible=this.createSurveyNomMas50;
     console.log(' this.secciones', this.secciones);
    if (this.recrearEncuestaBtn==false) {
      this.numSecciones=0;
      this.indices=[];
      this.secciones.forEach((seccion,i) => {
        if(seccion.visible){
          this.numSecciones++;
          this.indices.push(i);
        }
      });

      this.tamanioTagSecc = 100 / this.numSecciones;
      console.log("numsecciones:",this.numSecciones," | tamaniotag:",this.tamanioTagSecc," | progresoInicial:",this.progresoEncuesta);

    }
     // this.sumaProgresoProceso();
        this.pasoCorrecto();
        let dataUsuarios={
          productoId: localStorage.getItem('productoID'),
        }
        this.pasoUsuarios(dataUsuarios);
      }else{

        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }

  pasoUsuarios(data:any){
    this.sumaProgresoProceso(this.recrearEncuestaBtn);
    this.programacionServicen35.saveUsuarios(data).subscribe((respuesta:any) => {
      console.log('saveUsuarios',respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        console.log('this.createSurveyNomMenos50',this.createSurveyNomMenos50);
        if (this.createSurveyNomMenos50) {
          this.encuestaMenos50(data);
        }else{
          this.encuestaMas50(data);
        }
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }

  encuestaMenos50(data:any){
    this.sumaProgresoProceso();
    let data1 = {
      productoId: localStorage.getItem('productoID'),
    };
    this.programacionServicen35.crearEncuestamenos50(data1).subscribe((respuesta:any) => {
      console.log('crearEncuestamenos50',respuesta);
      if(respuesta.success == true){
        this.pasoCorrecto();
        if (this.createSurveyNomMas50) {
          this.encuestaMas50(data1);
        }else{
            console.log('se crea la encuesta por primera vez xoxoxoxoxoox',this.encuestaCreada);
          if (!this.encuestaCreada) {
            this.generaURL();
          }
        }
      }else{
        // if(respuesta.message == "Error saving questions") {
        //   let textoNoClaves = 'MODALES.CERTIV3.Error saving questions';
        //   this.translateSrv.get(textoNoClaves).subscribe((res: string) => { textoNoClaves = res; });
        //   Swal.fire({
        //     title: textoNoClaves,
        //     icon: "warning",
        //     confirmButtonColor: '#e40601'
        //   });
        // }
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }

  encuestaMas50(data:any){
    this.sumaProgresoProceso();
    let data1 = {
      productoId: localStorage.getItem('productoID'),
    };
  this.programacionServicen35.crearEncuesta50(data1).subscribe((respuesta:any) => {
      console.log('crearEncuesta50',respuesta);
      if(respuesta.success == true){
        this.pasoCorrecto();
        // this.encuestaMas50(data1);
        console.log('se crea la encuesta por primera vez xoxoxoxoxoox',this.encuestaCreada);

        if (!this.encuestaCreada) {
          this.generaURL();
        }
      }else{
        // if(respuesta.message == "Error saving questions") {
        //   let textoNoClaves = 'MODALES.CERTIV3.Error saving questions';
        //   this.translateSrv.get(textoNoClaves).subscribe((res: string) => { textoNoClaves = res; });
        //   Swal.fire({
        //     title: textoNoClaves,
        //     icon: "warning",
        //     confirmButtonColor: '#e40601'
        //   });
        // }
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }

  pasoNPS(data:any){
    this.sumaProgresoProceso();
    let data1 = {
      productoId: localStorage.getItem('productoID'),
      typeSection:1,
      accionText:'saveSeccionNps',
      userAdministrator:this.nameUserAdmin,
    };
    this.encuestaService.crearEncuestaSeccionesCer3(data1).subscribe((respuesta:any) => {
      console.log('pasoNPS',respuesta);
      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        if(respuesta.message == "Error saving questions") {
          let textoNoClaves = 'MODALES.CERTIV3.Error saving questions';
          this.translateSrv.get(textoNoClaves).subscribe((res: string) => { textoNoClaves = res; });
          Swal.fire({
            title: textoNoClaves,
            icon: "warning",
            confirmButtonColor: '#e40601'
          });

        }
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoReactivos(data:any){
    let data1 = {
      productoId: localStorage.getItem('productoID'),
      typeSection:2,
      accionText:'saveSeccionReactivos',
      userAdministrator:this.nameUserAdmin,
    };
    this.sumaProgresoProceso();
    this.encuestaService.crearEncuestaSeccionesCer3(data1).subscribe((respuesta:any) => {
      console.log('pasoReactivos',respuesta);
      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoControl(data:any){
    this.sumaProgresoProceso();
    let data1 = {
      productoId: localStorage.getItem('productoID'),
      typeSection:3,
      accionText:'saveSeccionControl',
      userAdministrator:this.nameUserAdmin,
    };
    this.encuestaService.crearEncuestaSeccionesCer3(data1).subscribe((respuesta:any) => {
      console.log("pasoControl",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoDemograficos(data:any){
    this.sumaProgresoProceso();
    let data1 = {
      productoId: localStorage.getItem('productoID'),
      typeSection:4,
      accionText:'saveSeccionDemogra',
      userAdministrator:this.nameUserAdmin,
    };
    this.encuestaService.crearEncuestaSeccionesCer3(data1).subscribe((respuesta:any) => {
      console.log("pasoDemograficos",respuesta);
      if(respuesta.message == "Error saving questions") {
        let textoNoClaves = 'MODALES.CERTIV3.Error saving questions';
        this.translateSrv.get(textoNoClaves).subscribe((res: string) => { textoNoClaves = res; });
        Swal.fire({
          title: textoNoClaves,
          icon: "warning",
          confirmButtonColor: '#e40601'
        });

      }

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{

        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoAdicionales(data:any){
    this.sumaProgresoProceso();
    let data1 = {
      productoId: localStorage.getItem('productoID'),
      typeSection:7,
      accionText:'saveSeccionAdicion',
      userAdministrator:this.nameUserAdmin,
    };
    this.encuestaService.crearEncuestaSeccionesCer3(data1).subscribe((respuesta:any) => {
      console.log("pasoAdicionales",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoForall(data:any){
    this.sumaProgresoProceso();
    let data1 = {
      productoId: localStorage.getItem('productoID'),
      typeSection:6,
      accionText:'saveSeccionForall',
      userAdministrator:this.nameUserAdmin,
    };
    this.encuestaService.crearEncuestaSeccionesCer3(data1).subscribe((respuesta:any) => {
      console.log("pasoForall",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }
  pasoAbiertas(data:any){
    this.sumaProgresoProceso();
    let data1 = {
      productoId: localStorage.getItem('productoID'),
      typeSection:5,
      accionText:'saveSeccionAbier',
      userAdministrator:this.nameUserAdmin,
    };
    this.encuestaService.crearEncuestaSeccionesCer3(data1).subscribe((respuesta:any) => {
      console.log("pasoAbiertas",respuesta);

      if(respuesta.success == true){
        this.pasoCorrecto();
        this.siguientePaso(data);
      }else{
        this.pasoFallido();
      }

    }, error => {
      this.pasoFallido();
      console.log(error);
    });
  }

  sumaProgresoProceso(bandera?:boolean){

    if(this.seccionesCompletas == 0){
      this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
    }
    else{
      if (bandera==false) {
        this.progresoEncuesta=0;
        this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
        this.progresoEncuesta += this.tamanioTagSecc;

      }else{
        this.progresoEncuesta += this.tamanioTagSecc;
      }
    }
  }

  pasoCorrecto(){
    this.secciones[this.indices[this.seccionesCompletas]].completo = true;
    if(this.secciones[this.indices[this.seccionesCompletas+1]]){
      setTimeout(() => {
        this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].proceso;
      }, 200);
    }
    else{
      setTimeout(() => {
        this.procesoActual = "SHEDULE2_0.SECCIONES.DETALLES";
      }, 200);
    }
    this.seccionesCompletas++;
    this.checkFinProceso();
  }

  siguientePaso(data:any){
    if(this.indices[this.seccionesCompletas]){
      switch (this.secciones[this.indices[this.seccionesCompletas]].id) {
        case 'NPS': this.pasoNPS(data); break;
        case 'Reactivos': this.pasoReactivos(data); break;
        case 'Control': this.pasoControl(data); break;
        case 'Demograficos': this.pasoDemograficos(data); break;
        case 'Abiertas': this.pasoAbiertas(data); break;
        case 'Forall': this.pasoForall(data); break;
        case 'Adicionales': this.pasoAdicionales(data); break;
      }
    }
  }

  pasoFallido(){
    this.secciones[this.indices[this.seccionesCompletas]].fallo = true;
    setTimeout(() => {
      this.procesoActual = this.secciones[this.indices[this.seccionesCompletas]].error;
    }, 200);
    this.procesoFinalizado = true;
    this.procesoOK = false;
    this.recrearEncuesta=true;
  }

  async checkFinProceso(){
    console.log('mando a llamar esta funcion que quiero saber ');

    if(this.seccionesCompletas == this.numSecciones){
      this.progresoEncuesta = this.progresoEncuesta + this.tamanioTagSecc/2;
      // setTimeout(() => { resolve(
        this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_2'),1);
        if(this.seccEspHabilitadas == true){
          console.log("secciones especiales habilitadas, recuperando usuarios de prueba");
          // const respuesta: any = await this.encuestaService.getUserSeccionEspecial().toPromise();
          // console.log("getUserSeccionEspecial:",respuesta);
        }
        // this.getPilotoDataEncuesta();
        this.getsurveyPilot();
        this.revisarModificaciones.emit(true);
        this.recrearEncuestaBtn = true;
      // )}, 200);
      this.procesoFinalizado = true;
      this.recrearEncuesta = true;
      this.seccionEncuesta = true;
      this.checarEncuesta=true;
      if (this.modalCambios) {
        const respuesta = await this.odsService.updateFlagCambios(localStorage.getItem('companyID'),localStorage.getItem('productoID'), { modalFlag: false }).toPromise().then((response:any) => {
          console.log(response);
          this.obtieneCertificarActual();
          this.actualizaFlagCambios.emit(true);
        });
      }
      this.obtieneCertificarActual();
    }
  }

  surveyCheckService(){
    this.programacionService.surveyCheck(this.token).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.datosSurveyCheck=respuesta.result;
      this.surveyCheck();
    }, error => {
    });
  }

  surveyCheck(){
      const dialogRef = this.dialog.open(SurveyCheckComponent, {
        width: '40%',
        data: {
          datos: this.datosSurveyCheck
        }
      });
  }

  verHistorialCreacion(){
    const dialogRef = this.dialog.open(ModalRecoComponent, {
      width: '40%',
      data: {
        opcion: 'historial',
        offsetPipe: this.offsetPipe,
        idiomaActual: this.idiomaActual,
      }
    });
  }

  infoEdicionEncuesta(){
    let mensaje = this.translateSrv.instant('EDITOR.ACERCADE');
    // this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CREADA_2'),1);
    this.mensajeSwal(mensaje,4);
  }

  navegaEdicionEnucuesta(){
    let rutaProducto: string;
    switch (localStorage.getItem('tipoProducto')) {
      case 'c3': rutaProducto = 'certify_t3'; break;  //certificar 3
      case 'm7': rutaProducto = 'measurement_t7'; break;  //medir 3
      case 'p1': rutaProducto = 'pulse_t1'; break;  //pulse 3
      case 'f1': rutaProducto = 'focus_t1'; break;  //focus 3
      case 'am1': rutaProducto = 'amco_1'; break;  //focus 3
      case 'td1': rutaProducto = 'traba_digno'; break;  //focus 3
      case 'pe1': rutaProducto = 'prime_emple'; break;  //focus 3
    }
    this.router.navigate([`/${rutaProducto}/wizard/surveyEditor`]);
  }

  enviaOrdenWizardNotificiaciones(){
    // this.wizardService.puenteDatosNotificaciones("100"); //100 = actualiza los status de los steps
    let datos:any={actua:"100",nivelNotif: this.nivelNotificacion}
    this.authService.puenteDatosQuick(datos);
  }

  getsurveyPilot(){
    let dataEnc={
      productoId: this.productoCertificar.idNorma35
    };

    this.programacionServicen35.obtenerPilito(dataEnc).subscribe((response:backInter.getPilotoN35) => {
      console.log("pilot",response);
      // console.log(response);
      if(response.message == '200'){

      }else if(response.success){
        let encuestaOk = true;
        if(encuestaOk){
                this.procesoFinalizado = true;
                this.checarEncuesta=true;
                this.procesoOK = true;
                this.progresoEncuesta = 100;
                this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
                this.recrearEncuestaBtn = true;
                this.recrearEncuesta = true;
                this.encuestaCreada = true;
                this.seccionEncuesta = true;
        }

        this.dataPiloto.emit({
          data: response,
          procesoFinalizado: this.procesoFinalizado,
          productoCertificar: this.productoCertificar
        });



        this.secciones.forEach(seccion => {
               switch (seccion.id) {
                 case 'encuesta':
                 seccion.visible = true;
                 seccion.completo = true;
                 break;
                 case 'usuarios':
                 seccion.visible = true;
                 seccion.completo = true;
                 break;
                 case 'encuesta-50':
                 if (response.urlMenos50!="") {
                   seccion.visible = true;
                   seccion.completo = true;

                 }
                 break;
                 case 'encuesta+50':
                 if (response.urlMas50!="") {
                   seccion.visible = true;
                   seccion.completo = true;

                 }
                 break;

                 break;
               }
             });


      //   this.pilotSurvey=true;
      //   this.encuestaOk = true;
      //   this.usuariosOk = true;
      //   if(response.urlMas50.length > 1){
      //     this.mas50Ok = true;
      //   }
      //   if(response.urlMenos50.length>1){
      //     this.menos50Ok = true;
      //   }
      //
      }
    }, error => {
      console.log(error);
    });
  }

  generaURL(){

    let datos = {
      producto: '63',
      productoId: this.productoCertificar.idNorma35,
      urlLarga: DATOS_API.urlSurveyAutologin+"?cm="+localStorage.getItem('companyID')+"&pr="+3+"&pid="+this.productoCertificar.idNorma35
      //urlLarga: DATOS_API.urlSurveyAutologin+'/#/'+"?cm="+this.idEmpresa+"&pr="+3+"&pid="+this.productoCertificar35.idNorma35
    };
    console.log(datos);
    this.programacionServicen35.creaUrlAutologin(datos).subscribe((respuesta:backInter.getPilotoN35)=>{
      console.log(respuesta);
    });
  }
}
